import { type Observable } from 'rxjs';

import { type ChatContext } from './chat-context.models';

export interface ChatContextProvider {
  readonly priority: number;
  readonly context$: Observable<ChatContext | null>;
}

export const CHAT_CONTEXT_PRIORITY = {
  fullPageArea: 0,
  overlayArea: 1,
} as const;
